import { IMortgageDetails } from "@/shared/models/interfaces/response/morgage/mortgage-detail.response";
import {
  detailsPropertiesAdapter,
  I_DetailsPropertiesAdapter
} from "@/src-refactor/modules/private/realestate/adapters/properties/details-properties.adapter";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import useTemplateDomToPdf from "../util/templateDomToPdf";
import { Options } from "react-to-pdf";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

function RealEstateDetailsContext(props: IRealEstateDetailsContextProps) {
  const snapshot = useTemplateDomToPdf();
  const setup = useMemo(() => {
    if (props.propertyData) {
      try {
        return {
          propertyData: detailsPropertiesAdapter(props.propertyData!)
        };
      } catch (e) {
        return { propertyData: null } as const;
      }
    }
    return {
      propertyData: null
    } as const;
  }, [props.propertyData]);

  const refetchData = () => {
    if (props.refetchData) {
      props?.refetchData();
    }
  };

  const config = {
    values: setup.propertyData,
    refetchData,
    snapshot
  };

  return (
    <RealEstateDetailContext.Provider value={config}>
      {props.children}
    </RealEstateDetailContext.Provider>
  );
}
export default RealEstateDetailsContext;

export const useRealEstateDetailContext = (key?: keyof IMortgageDetails) => {
  const context = useContext(RealEstateDetailContext);
  if (!context) {
    throw new Error("useOwnerContext must be used within a OwnerContext");
  }
  const { values, refetchData, snapshot } = context;
  // const valueForKey = key ? values[key] : undefined;
  return { PROPERTY_DETAIL: values, refetchData, snapshot };
};

interface ContextMortgageDetails {
  values: I_DetailsPropertiesAdapter;
  refetchData: () => void;
  snapshot: {
    makePdf: (dom: HTMLElement, options?: Options) => Promise<any>;
    loading: boolean;
  };
}
const RealEstateDetailContext = createContext<ContextMortgageDetails | null>(null);

interface IRealEstateDetailsContextProps {
  children: JSX.Element | JSX.Element[];
  propertyData: IPropertyDetailsResponse;
  refetchData?: () => void;
}
